import clearM8LocalStorage from './clearM8LocalStorage';
import { clearOtpDelivery } from './otpDelivery';

// Clears all app localStorage and impersonation-boundary-specific keys.
// Use this at impersonation start/stop boundaries instead of calling
// clearM8LocalStorage() directly — it also clears 2FA keys that normal
// logout preserves for login form pre-fill.
export default function clearImpersonationLocalStorage() {
  clearM8LocalStorage();
  // Clear 2FA keys on impersonation boundary (not cleared by clearM8LocalStorage
  // because normal logout should preserve email for login form pre-fill)
  localStorage.removeItem('email');
  localStorage.removeItem('otp_auth_token');
  localStorage.removeItem('needs2FA');
  // clearM8LocalStorage already lists these; cleared explicitly so this boundary
  // keeps owning every OTP key even if that list changes.
  clearOtpDelivery();
}
